import * as angular from "angular";
import {IController} from "angular";
import {LocationType} from "../../../commons/types/location.type";
import {SelectFilterType} from "../../../commons/types/select-filter.type";

export class RuleLocationDetailsComponent implements IController {

  locationDetails: { locationType: string, locationId: string };
  type: string;
  bringozSelectParams: any;
  onChange: Function;

  public locationTypes: typeof LocationType = LocationType;
  public allowedLocationTypes: LocationType[] = [LocationType.ACCOUNT, LocationType.DEPOT, LocationType.CUSTOMER];
  public selectFilterType: typeof SelectFilterType = SelectFilterType;

  constructor() {

  }

  $onInit() {
    if (!this.locationDetails) {
      this.locationDetails = {
        locationType: undefined,
        locationId: undefined
      }
    }
  }

  onChangeLocationType(type: LocationType) {
    this.locationDetails.locationType = type;
    this.onChange({locationDetails: this.locationDetails})
  }

  onChangeLocation(id: string) {
    this.locationDetails.locationId = id;
    this.onChange({locationDetails: this.locationDetails})
  }

}

angular
  .module('bringoz.admin.ruleEngine')
  .component('ruleLocationDetails', {
    bindings: {
      locationDetails: '<',
      type: '<',
      bringozSelectParams: '<',
      onChange: '&'
    },
    template: require('./rule-location-details.html').default,
    controller: RuleLocationDetailsComponent
  });
